import type { DocBrand } from '../../types/docops';

export const DEFAULT_BRAND_CONFIG: DocBrand = {
  id: 'hemologix',
  name: 'HemoLogix',
  status: 'active',
  createdAt: '2026-02-11T00:00:00.000Z',
  updatedAt: '2026-02-11T00:00:00.000Z',
  config: {
    // Brand
    brandName: 'HemoLogix',
    brandDomain: 'hemologix.com',
    brandEntity: 'HemoLogix LLC',
    stateOfFormation: 'Florida',
    ein: '',
    marketVertical: "Women's Hormone / Longevity Health Optimization",
    productType: 'AI-powered health analysis platform',
    effectiveDate: '2026-03-01',

    // People
    ceoName: 'Stan Van Meter',
    ceoEmail: '',
    medicalDirectorName: 'Dr. Christopher Calapai, D.O.',
    mdCredentials: 'D.O.',
    mdLicenseStates: [],
    pcEntityName: 'CC Medical PC',
    pcOwnerName: 'Dr. Christopher Calapai, D.O.',
    trustName: '',
    trustTrusteeName: '',

    // Partners
    telehealthNetwork: 'OpenLoop',
    pharmacyPartner: '',
    paymentProcessor: 'Stripe',
    fulfillmentPartner: '',
    cloudProvider: 'Google Cloud / Firebase',

    // Financials
    consultationFee: 49,
    telehealthCost: 25,
    pcRetainer: 0,
    mdRetainer: 0,
    ipLicenseRoyaltyPercent: 0,
    supplementMarginPercent: '',

    // Contacts
    legalEmail: 'legal@hemologix.com',
    privacyEmail: 'privacy@hemologix.com',
    supportEmail: 'support@hemologix.com',
    complianceEmail: 'compliance@hemologix.com',

    // Addresses
    businessAddress: '',
    registeredAgentAddress: '',

    // Jurisdictions (drives regulatory requirements)
    jurisdictions: ['FL', 'WA', 'CT', 'CA'],

    // Document variables (v2)
    arbitrationCounty: 'Miami-Dade',
    tier1Price: '',
    tier1PriceDescription: '',
    dmcaEmail: 'dmca@hemologix.com',
    lastUpdatedDate: '2026-03-01',

    // Policy URLs (populated once published)
    privacyPolicyUrl: 'https://hemologix.com/privacy',
    chdPolicyUrl: 'https://hemologix.com/consumer-health-data',
    hipaaNoticeUrl: 'https://hemologix.com/hipaa-notice',
    telehealthConsentUrl: 'https://hemologix.com/telehealth-consent',
    cookiePolicyUrl: 'https://hemologix.com/cookies',

    // Agent identity (v5 — Fix 2: brand identity in AI prompts)
    agentIdentity: {
      platformName: 'Hemologix',
      platformNameFormal: 'HemoLogix',
      nurseRole: 'Hemologix Intake Nurse',
      analystRole: 'HemoLogix Lab Analyst (Captain)',
      protocolBuilderRole: 'HemoLogix Protocol Builder',
      reportEngineRole: 'Hemologix Report Engine',
      kFrameworkOwner: "Stan Van Meter",
      clinicalPhilosophy: 'evidence-based reasoning, intellectual honesty, and a commitment to patient autonomy',
      disclaimerShort: 'I provide wellness optimization analysis, not medical advice. Always consult your healthcare provider.',
    },

    // Tier configuration (v3)
    tiers: {
      tier1: {
        name: 'AI-Powered Lab Analysis',
        enabled: true,
        pricingModel: 'free',
        price: null,
        priceDescription: null,
        refundWindow: null,
        refundPolicy: null,
      },
      tier2: {
        name: 'Telehealth Consultations',
        enabled: true,
        pricingModel: 'paid',
        price: '$49.00',
        priceDescription: 'per consultation',
        refundWindow: null,
        refundPolicy: 'See cancellation policy',
      },
      tier3: {
        name: 'Supplement Marketplace',
        enabled: true,
        pricingModel: 'paid',
        price: 'varies',
        priceDescription: 'per product',
        refundWindow: '30 days unopened',
        refundPolicy: 'See return policy',
      },
    },
  },
};
